<script>
import BestRecruitLayout from './components/MenuList'
import Surrounding from './components/Surrounding'
import Welfare from './components/Welfare'
import Multiple from './components/Multiple'
export default {
  page() {
    return {
      title: `菁英招募 | 生活在零壹`,
    }
  },
  components: {
    BestRecruitLayout,
    Surrounding,
    Welfare,
    Multiple,
  },
  props: {
    aboutCompany: {
      type: Object,
      default: () => {
        return {}
      },
    },
  },
  data() {
    return {
      type: 'life',
      aboutCompany1: {
        slider: [
          {
            title: '卓越地理位置',
            description: '辦公室位於內湖科技園區，擁有卓越的地理位置、健全的生活機能、活絡的交通網路及先進的資訊脈絡，鄰近西湖捷運站，步行約5-6分鐘。',
          },
          {
            title: '優質工作環境',
            description: '零壹秉持著「人才即為公司重要資產」的信念，除了積極培育科技業人才，更用心關懷同仁，致力於提供優質的工作環境，讓同仁能在工作中實現理想、激發創意，能夠快樂工作、熱情生活!',
          },
          {
            title: '重視團隊氛圍',
            description:
              '位於9樓的交誼廳，視野景觀怡人，員工可以在交誼廳一起用餐，增進彼此情誼，舒壓話家常，另外明亮寬敞的開會空間，在重視團隊合作的公司文化氛圍中，員工可以盡情激盪創意，一起為團隊目標努力。',
          },
          {
            title: '友善職場環境',
            description:
              '在零壹，我們不只關心員工在職涯上的成就，在員工的健康照護上更是不餘遺力，除了每年安排定期健康檢查，在硬體設備上，公司提供頂級咖啡機、有機咖啡豆、蒸飯箱、微波爐、員工停車位等，另外致力打造女性友善職場環境，設有舒適且隱私不受打擾的哺集乳室，產後哺集乳無壓力。',
          },
        ],
      },
    }
  },
}
</script>
<template>
  <BestRecruitLayout>
    <Surrounding :about-company="aboutCompany.environment"></Surrounding>
    <Welfare :about-company="aboutCompany.welfare"></Welfare>
    <Multiple :carousel-list="aboutCompany['diversity']"></Multiple>
  </BestRecruitLayout>
</template>
<style lang="scss" module>
</style>
